import App from "../../services/App/App.js";
import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import RinvD from "./Details/RinvD.vue";
import RinvE from "./Edit/RinvE.vue";
import RinvExL from "./ExportList/RinvExL.vue";
import RinvL from "./List/RinvL.vue";
import RinvN from "./New/RinvN.vue";
import RinvPD from "./PrintDetails/RinvPD.vue";
import RinvPL from "./PrintList/RinvPL.vue";
import RinvPT from "./PrintThermal/RinvPT.vue";

export default {
  Path: {
    Details: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Details),
    Edit: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Edit),
    ExportList: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.ExportList),
    List: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.List),
    New: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.New),
    PrintList: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.PrintList),
    PrintThermal: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.PrintThermal)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Details),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.Details),
        component: RinvD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.Details),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_Details,
          moduletype: AppModuleType.Details
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Edit),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.Edit),
        component: RinvE,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.Edit),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_Edit,
          moduletype: AppModuleType.Edit,
          cancel: {
            url: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.ExportList),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.ExportList),
        component: RinvExL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.ExportList),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_ExportList,
          moduletype: AppModuleType.ExportList
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.List),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.List),
        component: RinvL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.List),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_List,
          moduletype: AppModuleType.List,
          // actions
          exportlist: {
            module: RouterModel.getModule(AppModule.RtnInvoice),
            moduleattr: AppModuleAttr.RtnInvoice_Act_ExportList,
            moduletype: AppModuleType.ExportList
          },
          new: {
            module: RouterModel.getModule(AppModule.RtnInvoice),
            moduleattr: AppModuleAttr.RtnInvoice_Act_New,
            moduletype: AppModuleType.New
          },
          printlist: {
            module: RouterModel.getModule(AppModule.RtnInvoice),
            moduleattr: AppModuleAttr.RtnInvoice_Act_PrintList,
            moduletype: AppModuleType.PrintList
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.New),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.New),
        component: RinvN,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.New),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_New,
          moduletype: AppModuleType.New,
          cancel: {
            url: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.PrintDetails),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.PrintDetails),
        component: RinvPD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.PrintDetails),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_PrintDetails,
          moduletype: AppModuleType.PrintDetails
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.PrintList),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.PrintList),
        component: RinvPL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.PrintList),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_PrintList,
          moduletype: AppModuleType.PrintList
        }
      },
      {
        path: RouterModel.getPath(AppModule.RtnInvoice, AppModuleType.PrintThermal),
        name: RouterModel.getName(AppModule.RtnInvoice, AppModuleType.PrintThermal),
        component: RinvPT,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.RtnInvoice, AppModuleType.PrintThermal),
          module: RouterModel.getModule(AppModule.RtnInvoice),
          moduleattr: AppModuleAttr.RtnInvoice_Act_PrintThermal,
          moduletype: AppModuleType.PrintThermal
        }
      }
    ];
  }
}